<div class="custom-snackbar-container">
  <div class="custom-snackbar-data-wrapper">
    <span> {{ data.message }} </span>
  </div>
  @if (data.closeBtn) {
    <mat-icon
      fontSet="material-symbols-outlined"
      class="close-snackbar-btn"
      [inline]="true"
      (click)="snackBarRef.dismiss()"
      >cancel</mat-icon
    >
  }
</div>
